import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { pauseSubscriptionAction } from 'root-redux/actions/user'
import { selectUUID } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { PAUSE_SUBSCRIPTION_OPTION_VALUES } from 'modules/unsubscribe/pages/PauseSubscription/constants'

import { eventLogger } from 'services/eventLogger.service'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { FemiFeedbackPopup } from '../../components/FemiFeedbackPopup'
import { FemiOption } from '../../components/FemiOption'
import { FemiPageContainer } from '../../components/FemiPageContainer'
import { useCancelSubscription } from '../../hooks/useCancelSubscription'
import { FemiContent, FemiOptions } from '../../styles'
import { StyledFemiPauseSubscription as S } from './FemiPauseSubscription.styles'

export const FemiPauseSubscription: React.FC = () => {
  const { search } = useLocation()
  const { t } = useTranslation()
  const dispatch: TAppDispatch = useDispatch()
  const userId = useSelector(selectUUID)

  const {
    isFeedbackPopupShown,
    closeFeedbackPopup,
    cancelSubscription,
    goToCancellation,
  } = useCancelSubscription()
  const isSubmittedRef = useRef(false)

  useEffect(() => {
    eventLogger.logPauseSubscriptionScreenShow(userId)
  }, [userId])

  const handlePause = () => {
    if (isSubmittedRef.current) return

    isSubmittedRef.current = true
    eventLogger.logPauseSubscriptionScreenClose(
      PAUSE_SUBSCRIPTION_OPTION_VALUES.YES,
      userId,
    )
    dispatch(pauseSubscriptionAction())
    goTo({ pathname: PageId.CONTINUED_SUBSCRIPTION, search })
  }

  const handleDecline = () => {
    eventLogger.logPauseSubscriptionScreenClose(
      PAUSE_SUBSCRIPTION_OPTION_VALUES.NO,
      userId,
    )
    goToCancellation()
  }

  return (
    <FemiPageContainer hasNavigation>
      <FemiContent>
        <S.Description>
          {t('retention.femi.pauseSubscription.description')}
        </S.Description>
        <S.Title isAlignedLeft>
          {t('retention.femi.pauseSubscription.title')}
        </S.Title>
        <FemiOptions>
          <FemiOption onClick={handlePause}>
            {t('retention.femi.pauseSubscription.yes')}
          </FemiOption>
          <FemiOption onClick={handleDecline}>
            {t('retention.femi.pauseSubscription.no')}
          </FemiOption>
        </FemiOptions>
      </FemiContent>
      <FemiFeedbackPopup
        isShown={isFeedbackPopupShown}
        onComplete={cancelSubscription}
        onClose={closeFeedbackPopup}
      />
    </FemiPageContainer>
  )
}
